import ArticleHeaderControls from '@bridebook/web/app-basic/components/articles/header-controls/header-controls';
import Sidebar from '@bridebook/web/app-basic/components/articles/sidebar/sidebar';
import { getIsDesktop } from '@bridebook/web/app-basic/lib/app/selectors';
import { getArticle } from '@bridebook/web/app-basic/lib/article/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { memo } from 'react';
import { Box, Container } from '@bridebook/ui';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { getTagsList } from '@bridebook/web/app-shared/lib/articles/utils';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { FloatingScrollButton } from '@bridebook/web/app-basic/components/articles/floating-scroll-button/floating-scroll-button';
import componentStyles from './container.style';

interface IProps {
  renderedContent: any;
  pinImage: string;
}

const ArticleContent = ({ renderedContent, pinImage }: IProps) => {
  const article = useSelector(getArticle);
  const isDesktop = useSelector(getIsDesktop);
  const tagsList = getTagsList(article);
  const { title, subtitle = '' } = article || {};

  const styles = componentStyles();

  return (
    <Container style={styles.wrapper}>
      <Box style={styles.paddingWrapperUpper}>
        <Box style={styles.titleSubtitleWrap}>
          <Box as="h1" style={styles.title}>
            {title}
          </Box>
          {!isDesktop && (
            <Box style={styles.tagContainer}>
              {tagsList.map((tag) => (
                <Link href={`${UrlHelper.advice}/${tag.slug}`} key={tag.slug}>
                  <Box id={`article-tag-${tag.slug}`} style={styles.tag}>
                    {tag.name}
                  </Box>
                </Link>
              ))}
            </Box>
          )}
          {subtitle && (
            <Box as="h2" style={styles.subtitle}>
              {subtitle}
            </Box>
          )}
          <ArticleHeaderControls pinImage={pinImage} />
        </Box>
      </Box>
      <Box as="img" style={styles.img} src={article?.featured_image.source} alt="" />
      <Box style={styles.paddingWrapperLower}>
        <Box style={styles.articleContainerWrap}>
          <Box style={styles.articleContainer}>
            {renderedContent}
            <ArticleHeaderControls pinImage={pinImage} withSubtitle />
          </Box>
          {isDesktop && <Sidebar />}
        </Box>
        {!isDesktop && <FloatingScrollButton />}
      </Box>
    </Container>
  );
};

export default memo(ArticleContent);
